import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'luzi',
} as IModuleProps;
